export default __webpack_public_path__ + "assets/upload_logo_human.695f7b.png";